import React from "react";
import PropTypes from "prop-types";
import ReviewCard from "./reviewCard";

export default function ReviewList({
    reviews,
    total,
    isTypical,
    manufacturerName,
    loadMoreReviews,
    loadingMore
}) {
    const filteredReviews = reviews.filter(review => !isTypical || review.isTypical);

    return (
        <>
            {filteredReviews && filteredReviews.length > 0 ? (
                <>
                    {filteredReviews.map((review, index) => (
                        <ReviewCard
                            key={index}
                            review={review}
                            manufacturerName={manufacturerName}
                        />
                    ))}

                    {/* View More Button */}
                    {filteredReviews.length < total && (
                        <div className="product-power-wrap">
                            <button
                                type="button"
                                className="prod-detail-cta wishlist-btn"
                                onClick={loadMoreReviews}
                            >
                                {loadingMore ? "Loading..." : "Load More"}
                            </button>
                        </div>
                    )}
                </>
            ) : (
                <div className="product-detail-list" style={{ margin: "0.5em 0 0" }}>
                    <p>No reviews yet.</p>
                </div>
            )}
        </>
    );
}

ReviewList.propTypes = {
    reviews: PropTypes.array.isRequired,
    total: PropTypes.number.isRequired,
    isTypical: PropTypes.bool,
    manufacturerName: PropTypes.string,
    loadMoreReviews: PropTypes.func.isRequired,
    loadingMore: PropTypes.bool
};

ReviewList.defaultProps = {
    isTypical: false,
    manufacturerName: "",
    loadingMore: false
};
